var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterLeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6525 1H2.49756C2.35021 1 2.20872 1.06345 2.12307 1.18335C0.625645 3.27933 0.625644 8.72067 2.12307 10.8167C2.20872 10.9366 2.35021 11 2.49756 11H10.1084C10.4178 11 10.6529 10.7219 10.6014 10.4168L10.4134 9.30235C10.3821 9.11684 10.4576 8.92946 10.6088 8.81745L11.4806 8.17144C11.6238 8.06532 11.6997 7.89097 11.6798 7.71384L11.5327 6.40586C11.48 5.93735 12.0456 5.66294 12.381 5.9943L14.1739 7.76569C14.3175 7.90757 14.3617 8.12189 14.2859 8.30901L13.843 9.40315C13.7768 9.56655 13.8016 9.7527 13.9082 9.89311L14.5984 10.8023C14.6929 10.9269 14.8403 11 14.9966 11H23.6525C23.784 11 23.9126 10.9505 23.9915 10.8453C25.1921 9.24591 25.4717 2.98759 23.9947 1.15217C23.9122 1.04967 23.784 1 23.6525 1Z",
    fill: "#D9D9D9",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.6665C10 17.9273 10.9076 16.4379 13.6193 13.4207C13.8202 13.1972 14.1732 13.2015 14.3667 13.4313C16.5737 16.0522 18 18.2295 18 19.6665C18 21.1816 16.2678 23.0264 14 22.9997C11.5252 23.0122 10 21.1816 10 19.6665Z",
    fill: "#7AC8F5",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLeak);
export default __webpack_public_path__ + "static/media/water-leak.cb11114e90219d2800fc9146665760f5.svg";
export { ForwardRef as ReactComponent };